module.exports = __webpack_public_path__ + "img/电厂.0d293a8b.png";